import { call, put, takeLatest } from 'redux-saga/effects'

import { postBreeding, putBreeding, deleteBreeding } from '@galo-monitor/services/apis/galoMonitorApi/resources/breeding'

import { BreedingActions, BreedingTypes } from './duckBreeding'

function* saveBreeding({ breeding, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(breeding.id ? putBreeding : postBreeding, breeding)
    yield call(onSuccess)
  } catch (err) {
    yield put(BreedingActions.breedingError(err.message))
    yield call(onError, err)
  }
}

function* removeBreeding({ breeding, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(deleteBreeding, breeding)
    yield call(onSuccess)
  } catch (err) {
    yield put(BreedingActions.breedingError(err.message))
    yield call(onError, err)
  }
}

export default [
  takeLatest(BreedingTypes.SAVE_BREEDING, saveBreeding),
  takeLatest(BreedingTypes.REMOVE_BREEDING, removeBreeding)
]
